<template>
  <div>
    <nav>
          <div class="menu">
              <div class="logo">
                  <img src="@/images/logo.png" alt="ibon">
                  <span class="text1">上海亿邦工贸有限公司</span>
                  <span class="text2">SHANGHAI I.BON INDUSTRIAL CO.LTD</span>
              </div>            
          </div>
      </nav>
      <div class="img"></div>
      <div class="center">
          <div class="title">上海亿邦工贸有限公司</div>        
          <div class="sub_title">大数据信息融合、荧光渗透检测、多种荧光检测</div>
          <div class="btns">
              <button @click="goHome">了解更多</button>
              <button @click="goHref">联系我们</button>
          </div>
      </div>
      <div class="divmst_copyRight">
        <p>&copy; Copyright 2023 上海亿邦工贸有限公司. ALL Rights Reserved.<br/>
        <span>Designed By SHANGHAI I.BON</span></p>
        <a href="http://beian.miit.gov.cn/publish/query/indexFirst.action" target="_blank" title="沪ICP备19005913号-1">沪ICP备19005913号-1</a>
      </div>
  </div>                 
  </template>
  
  <script>
  import { useRouter } from "vue-router";
  export default {
      name: "App",
      setup(){
          const $router = useRouter()
          function goHome(){
              $router.push({path: '/about'}); 
              // 注意：router-link中链接如果是'/'开始就是从根路由开始，如果开始不带'/'，则从当前路由开始。
              
          }
          function goHref(){
            $router.push({path: '/contact'}); 
          }
          return{
              goHome,
              goHref,
          };
      }
  };
  
  </script>
  
  <style  scoped>
  *{
      margin: 0;
      padding:0;
      box-sizing: border-box;
      /* font-family: 'Microsoft YaHei' sans-serif; */
  }
  
  ::selection{
      color: #000;
      background: #fff;
  }
  nav{
      /* position: fixed; */
      position: sticky;
      top: 0;
      background: #1b1b1b;
      width: 100%;
      padding: 10px 0;
      z-index: 10;
  }
  nav .logo img{
      width: 60px;
      height: 60px;
      border-radius: 5px;
      vertical-align: middle;
      margin: 0.6em;
  }
  nav .menu{
      max-width: 1250px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px ;
  }
  .menu .logo .text1{
      color: #fff;
      /* font-size: 30px; */
      font-size: 2em;
      font-weight: 600;
      margin-left: 20px;
  }
  
  .menu .logo .text2{
      color: #fff;
      font-size: 28px;
      font-weight: 400;
      margin-left: 20px;
  }
  
  .img{
      background: url(@/images/img1.jpg) no-repeat;
      width: 100%;
      height: 80vh;
      background-size: cover;
      background-position: center;
      position: relative;
      
  }
  
  .img::before{
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      
  }
  
  .center{
      position: absolute;
      top: 52%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      padding: 0 20px ;
      text-align: center;     
  }
  
  .center .title{
      color: #fff;
      font-size: 50px;
      font-weight: 600;
      line-height:100px
  }
  
  .center .sub_title{
      color: #fff;
      font-size: 42px;
      font-weight: 600;
  }
  
  .center .btns{
      margin-top: 20px;
  }
  
  .center .btns button{
      height: 55ppx;
      width: 170px;
      border-radius: 5px;
      /* border: none; */
      margin: 0 10px;
      border: 2px solid white;
      font-size: 20px;
      font-weight: 500;
      padding: 5px 10px ;
      cursor: pointer;
      outline: none;
      transition: all 0.5 ease;
  }
  
  .center .btns button:first-child{
      color: #fff;
      background: none;
  }
  .center .btns button:first-child:hover{
      background: white;
      color: black;
  }
  
  .center .btns button:last-child{
      background: white;
      color: black;
  }
  
  .divmst_copyRight { 
    background-color:Black; 
    padding-bottom:2%; 
    text-align:center; 
    font-size:18px; 
    color:#666;}
   .divmst_copyRight span{    
    text-align:center; 
    font-size:18px; 
    color:#666;} 
   .divmst_copyRight  a{ color:#666;}
   .divmst_copyRight  a:hover{ color:#cccaca;}
  </style>